import React from 'react';

// The line icons from the design. Every one inherits currentColor unless the
// design pins a colour, so they follow whatever button they sit in.

export const SearchIcon = () => (
    <svg width="15" height="15" viewBox="0 0 14 14" fill="none" stroke="#8D959E" strokeWidth="1.6">
        <circle cx="6" cy="6" r="4.4" />
        <path d="M9.4 9.4 L12.6 12.6" />
    </svg>
);

export const ChevronLeftIcon = () => (
    <svg width="15" height="15" viewBox="0 0 13 13" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M8.2 2.6 L4 6.5 L8.2 10.4" />
    </svg>
);

/** Pan and select — the state the map is in when no drawing tool is armed. */
export const CursorIcon = () => (
    <svg width="15" height="15" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
        <path d="M3.4 2.4 L10.6 6.6 L7.3 7.5 L5.9 10.8 Z" />
    </svg>
);

export const BoxIcon = () => (
    <svg width="15" height="15" viewBox="0 0 13 13" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="1.7" y="2.6" width="9.6" height="7.8" strokeDasharray="2.4 1.8" />
    </svg>
);

export const RadiusIcon = () => (
    <svg width="15" height="15" viewBox="0 0 13 13" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="6.5" cy="6.5" r="4.6" strokeDasharray="2.4 1.8" />
        <circle cx="6.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
);

export const LayersIcon = () => (
    <svg width="16" height="16" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
        <path d="M7.5 1.9 L13.1 5 L7.5 8.1 L1.9 5 Z" />
        <path d="M2.6 7.4 L7.5 10.1 L12.4 7.4" />
        <path d="M2.6 9.9 L7.5 12.6 L12.4 9.9" />
    </svg>
);

export const FilterIcon = () => (
    <svg width="15" height="15" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
        <path d="M2.2 3.6 H11.8 M4 7 H10 M5.8 10.4 H8.2" />
    </svg>
);

export const CaretDownIcon = () => (
    <svg width="12" height="12" viewBox="0 0 11 11" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 4.3 L5.5 6.8 L8 4.3" />
    </svg>
);

export const ParcelLinesIcon = () => (
    <svg width="17" height="17" viewBox="0 0 13 13" fill="none" stroke="#8D959E" strokeWidth="1.4">
        <path d="M1.8 2.2 H11.2 V10.8 H1.8 Z M1.8 6.2 H7.4 M7.4 2.2 V10.8" />
    </svg>
);

export const HouseIcon = () => (
    <svg width="17" height="17" viewBox="0 0 13 13" fill="none" stroke="#8D959E" strokeWidth="1.4" strokeLinejoin="round">
        <path d="M1.9 5.9 L6.5 2.1 L11.1 5.9 V11 H1.9 Z" />
        <path d="M5.1 11 V7.7 H7.9 V11" />
    </svg>
);

export const ImportIcon = () => (
    <svg width="15" height="15" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
        <path d="M7 1.9 V8.6 M4.4 6.1 L7 8.7 L9.6 6.1" />
        <path d="M2.3 9.8 V11.4 H11.7 V9.8" />
    </svg>
);

/** The map action on the property list, alongside List and Map. */
export const MapPinIcon = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
        <path d="M7 12.4 C7 12.4 11.2 8.6 11.2 5.8 A4.2 4.2 0 0 0 2.8 5.8 C2.8 8.6 7 12.4 7 12.4 Z" />
        <circle cx="7" cy="5.7" r="1.5" />
    </svg>
);

export const BackIcon = () => (
    <svg width="16" height="16" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M9 3.5 L4.5 7.5 L9 11.5" />
    </svg>
);

export const CloseIcon = () => (
    <svg width="15" height="15" viewBox="0 0 13 13" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M3 3 L10 10 M10 3 L3 10" />
    </svg>
);

export const ExternalIcon = () => (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M3.6 7.4 L7.4 3.6 M4.2 3.6 H7.4 V6.8" />
    </svg>
);

export const PhoneIcon = () => (
    <svg width="14" height="14" viewBox="0 0 12 12" fill="none" stroke="#8D959E" strokeWidth="1.4">
        <path d="M2 2.8 C2 2 2.7 1.6 3.3 2 L4.6 3 C5 3.4 4.8 4 4.4 4.4 C4 4.8 4 5.2 5 6.4 C6 7.6 6.6 7.8 7.2 7.4 C7.8 7 8.3 7.2 8.7 7.6 L9.8 8.7 C10.2 9.2 9.9 10 9.1 10 C6 10 2 6 2 2.8 Z" />
    </svg>
);

export const MailIcon = () => (
    <svg width="14" height="14" viewBox="0 0 12 12" fill="none" stroke="#8D959E" strokeWidth="1.4">
        <rect x="1.4" y="2.6" width="9.2" height="6.8" rx="1" />
        <path d="M1.7 3.2 L6 6.6 L10.3 3.2" />
    </svg>
);

export const RefreshIcon = () => (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 7a5 5 0 1 1-1.46-3.54" />
        <path d="M12 2v3.2h-3.2" />
    </svg>
);

export const CopyIcon = () => (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4.6" y="4.6" width="7.4" height="7.4" rx="1.4" />
        <path d="M9.4 2.6H3.4A1.4 1.4 0 0 0 2 4v6" />
    </svg>
);

export const TickIcon = () => (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="#fff" strokeWidth="1.9">
        <path d="M2 5.2 L4 7.2 L8 2.8" />
    </svg>
);

export const CheckIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12.5 L9.5 17 L19 7.5" />
    </svg>
);

export const PlusIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
        <path d="M12 5 V19 M5 12 H19" />
    </svg>
);

export const ArrowIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#5E666F" strokeWidth="1.4">
        <path d="M2 6 H9 M6.5 3.5 L9.5 6 L6.5 8.5" />
    </svg>
);
